import React, { ReactNode } from 'react';

import styles from './Badge.module.scss';

type BadgeProps = {
  children: ReactNode;
  success?: boolean;
  warning?: boolean;
  danger?: boolean;
  cancel?: boolean;
  purple?: boolean;
  className?: string;
  onClick?: Function;
  darken?: boolean;
};

function Badge({
  children,
  success,
  warning,
  danger,
  cancel,
  purple,
  className = '',
  onClick,
  darken,
}: BadgeProps) {
  const _className = [styles.Badge];
  className && _className.push(className);
  success && _className.push(styles.success);
  warning && _className.push(styles.warning);
  danger && _className.push(styles.danger);
  cancel && _className.push(styles.cancel);
  purple && _className.push(styles.purple);
  darken && _className.push(styles.darken);
  onClick && _className.push(styles.clickable);

  function handleClick() {
    onClick && onClick();
  }

  return (
    <span className={_className.join(' ')} onClick={handleClick}>
      {children}
    </span>
  );
}

export default Badge;
